/**
 * Younika Beauty - Policy Page Enhancer & Cleanup
 * Safe, non-destructive script that removes leaked CSS code,
 * fixes lone bullet dots, and applies luxury formatting to headings.
 */
(function() {
  'use strict';

  function initPolicyEnhancer() {
    const policyContainer = document.querySelector('.shopify-policy__container, .custom-policy-wrapper');
    const pageContainer = document.querySelector('.page-width--policy');
    const isPolicyPage = policyContainer || pageContainer || window.location.pathname.includes('/policies/');

    if (!isPolicyPage) return;

    const bodyContainer = document.querySelector('.shopify-policy__body') ||
                          document.querySelector('.custom-policy-card') ||
                          document.querySelector('.rte');

    if (!bodyContainer) return;

    try {
      // 1. Clean leaked CSS text safely without removing any content
      cleanLeakedCss(bodyContainer);

      // 2. Fix lone bullet dots
      fixLoneBullets(bodyContainer);

      // 3. Convert any raw markdown links
      convertMarkdownLinks(bodyContainer);

      // 4. Style numbered section headings
      styleSectionHeadings(bodyContainer);

      // 5. Add luxury eyebrow & divider to title
      addHeaderAccents();

    } catch (e) {
      console.warn('[Younika Policy] Notice during enhancement:', e);
    }
  }

  /**
   * Safely removes leaked CSS code strings from text nodes only.
   * NEVER removes any HTML elements or content containers.
   */
  function cleanLeakedCss(container) {
    const walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT, null, false);
    const nodes = [];

    while (walker.nextNode()) {
      nodes.push(walker.currentNode);
    }

    nodes.forEach(node => {
      let val = node.nodeValue;
      if (
        val.includes('[data-custom-class') ||
        val.includes('list-style-type:') ||
        val.includes('ol li {')
      ) {
        val = val.replace(/\[data-custom-class[\s\S]*?word-break:[^;]+;\s*\}/gi, '');
        val = val.replace(/(\[data-custom-class[^\{<]+\{[^\}<]+\}\s*)+/gi, '');
        val = val.replace(/ul\s*\{\s*list-style-type:[\s\S]*?ol\s*li\s*\{[^}]*\}/gi, '');
        val = val.replace(/ul\s*\{\s*list-style-type:[^}]*\}\s*ul\s*>\s*li\s*>\s*ul[^\n<]*/gi, '');
        val = val.replace(/ol\s*li\s*\{\s*font-family:[^}]*\}/gi, '');
        node.nodeValue = val;
      }
    });
  }

  /**
   * Remove empty paragraphs that only contain a solitary bullet dot
   */
  function fixLoneBullets(container) {
    const bulletChars = ['•', '·', '●', '▪', '▫'];
    const leafNodes = container.querySelectorAll('p, span, div');

    leafNodes.forEach(el => {
      // Only check leaf elements with no children
      if (el.children.length === 0) {
        const text = el.textContent.trim();
        if (bulletChars.includes(text)) {
          el.remove();
        }
      }
    });
  }

  /**
   * Convert any unparsed markdown links: [text](url) -> <a>
   */
  function convertMarkdownLinks(container) {
    const mdRegex = /\[([^\]]+)\]\((https?:\/\/[^\s\)]+|mailto:[^\s\)]+)\)/g;
    const walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT, null, false);
    const nodes = [];

    while (walker.nextNode()) {
      if (mdRegex.test(walker.currentNode.nodeValue)) {
        nodes.push(walker.currentNode);
      }
    }

    nodes.forEach(node => {
      const parent = node.parentNode;
      if (!parent || parent.tagName === 'A') return;

      const html = node.nodeValue.replace(
        mdRegex,
        '<a href="$2" class="custom-policy-link" target="_blank" rel="noopener noreferrer">$1</a>'
      );

      const span = document.createElement('span');
      span.innerHTML = html;
      parent.replaceChild(span, node);
    });
  }

  /**
   * Style numbered section headings with luxury gold badges
   */
  function styleSectionHeadings(container) {
    const headings = container.querySelectorAll('h1, h2, h3, h4, p, strong');

    headings.forEach(el => {
      // Don't format if already badged
      if (el.querySelector('.policy-section-badge')) return;

      const text = el.textContent.trim();
      const match = text.match(/^(\d{1,2})\.\s+([A-Z\s&,/-]{3,})$/i);

      if (match) {
        const num = match[1];
        const title = match[2].trim();
        el.innerHTML = `<span class="policy-section-badge">${num}</span> ${title}`;
        el.classList.add('policy-section-title');
      }
    });
  }

  /**
   * Add high-end eyebrow and divider to the title container
   */
  function addHeaderAccents() {
    const titleContainer = document.querySelector('.shopify-policy__title, .custom-policy-header');
    if (!titleContainer) return;

    if (!document.querySelector('.custom-policy-eyebrow')) {
      const eyebrow = document.createElement('div');
      eyebrow.className = 'custom-policy-eyebrow';
      eyebrow.textContent = 'LEGAL & POLICIES · YOUNIKA BEAUTY';

      const divider = document.createElement('div');
      divider.className = 'custom-policy-divider';

      titleContainer.insertBefore(eyebrow, titleContainer.firstChild);
      titleContainer.appendChild(divider);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPolicyEnhancer);
  } else {
    initPolicyEnhancer();
  }
})();
